/** @format */

import * as yup from 'yup';

import {validate} from 'email-validator';

import {FormState} from '../../types';

export const validationSchema: yup.ObjectSchema<FormState> = yup.object({
  name: yup.string().trim().required('Обязательное поле'),
  email: yup
    .string()
    .trim()
    .when('$isEdit', {
      is: false,
      then: schema => schema.required('Обязательное поле'),
      otherwise: schema => schema.notRequired(),
    })
    .test('is-valid-email', 'Введен некорректный email-адрес', value =>
      value ? validate(value) : true,
    ),

  position: yup.string().trim().required('Обязательное поле'),
  companyIds: yup.array().defined(),
});
